/** Main project script */

// ensure the main object is defined
if (typeof(window.so) === 'undefined') {
    window.so = {};
}

// main code
window.so.app = {
    init: function () {
        this.toggleNavigation();
        this.searchPopoverTrigger();
        this.toggleSubNavigation();
        this.formLabelScootcher();
        $('.no-ss[href]').each(function () {
            if ($(this).attr('href') !== '') {
                var link = $(this).attr('href').split('#')[1];
                $(this).attr('href', '#' + link);
            }
        });
        $('[data-href]').addClass('jslink').on('click', function (e) {
            e.preventDefault();
            var link = $(this).attr('data-href');
            var newWindow = $(this).data('newwindow');
            if (newWindow == true) {
                window.open(link);
            } else {
                window.location.href = link;
            }
        });

        this.keepalive();
    },
    keepalive: function () {
        setInterval(function () {
            $.post(solout.absoluteBaseUrl + 'Security/ping');
        }, 600000);
    },
    toggleNavigation: function () {
        $(".nav-main-trigger").click(function(e) {
            e.preventDefault();

            window.so.app.closeSearchPopover();

            $(".nav-main").toggleClass('nav-main-open');
        });
    },
    toggleSubNavigation: function () {
        $(".nav-main-sub-menu-trigger").click(function() {
            var target = $(this).attr('data-target');

            if ($(this).attr('aria-expanded') === 'true') {
                $(this).attr('aria-expanded', 'false');
            } else {
                $(this).attr('aria-expanded', 'true');
            }

            $(target).toggleClass('nav-main-sub-menu-open');
        });
    },
    closeMegaMenu: function () {
        $(".nav-main").removeClass('nav-main-open');
        $(".mega-menu").removeClass('open');
    },
    closeSearchPopover: function () {
        $(".nav-main").removeClass('search-popover-open');
        $(".search-popover").removeClass('open');
    },
    searchPopoverTrigger: function () {
        $(".search-popover-trigger").click(function(e) {
            e.preventDefault();
            window.so.app.closeMegaMenu();

            $(".nav-main").toggleClass('search-popover-open');
            $(".search-popover, .suggestive-search-popover").toggleClass('open');
            // $(".search-popover form").toggle();
        });
    },
    formLabelScootcher: function () {
        let labels = document.querySelectorAll('.slide-label label');
        for (let i = 0; i < labels.length; i++) {
            let target = labels[i].htmlFor;
            if (target != '') {
                let fieldinput = document.getElementById(target);
                if (fieldinput.value == '') {
                    labels[i].parentNode.classList.add('set');
                }
                fieldinput.onfocus = function () {
                    labels[i].parentNode.classList.add('up');
                };
                fieldinput.onblur = function () {
                    if (fieldinput.value == '') {
                        labels[i].parentNode.classList.remove('up');
                    }
                };
            }
        }
    }
};

$(document).ready(function () {
    window.so.app.init();
});
